import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@services/auth.service';
import { ToastService } from '@services/toast.service';
import { AvailableUserScopes, userHasScope } from '../../../../../../common/common-types/user-scopes';

const orgIdFrom = (route: ActivatedRouteSnapshot | null): string | null => {
    for (let r = route; r; r = r.parent) {
        if (r.routeConfig?.path === 'organizations/:id') {
            return r.paramMap.get('id');
        }
    }
    return null;
};

/** Blocks a route unless the user holds `data.scope` in the current organisation. */
export const scopeGuard: CanActivateFn = async (route) => {
    // Everything is injected before the first await; the injection context ends there.
    const auth = inject(AuthService);
    const router = inject(Router);
    const toast = inject(ToastService);
    const translate = inject(TranslateService);
    const user = await auth.get();
    const orgId = orgIdFrom(route) ?? auth.organizationId();
    const scope = route.data['scope'] as AvailableUserScopes | undefined;

    if (userHasScope(user, orgId, scope)) {
        return true;
    }

    toast.showWarn(translate.instant('MISSING_ACCESS'));
    return router.createUrlTree(['/organizations', orgId]);
};
